import { Fragment } from 'react';
import { css } from '@emotion/react';
import { IDisclaimer, ESteps } from '../types/coreEntites/Organization';
import { useRecoilState } from 'recoil';
import { userStore } from 'stores/userStore';
import { BsInfo } from 'lib/icons';

const container = css`
	display: flex;
	align-items: flex-start;
	background: #c4c4c4;
	box-shadow: 0px -2px 24px rgba(21, 93, 148, 0.15);
	border-radius: 5px;
	font-family: Montserrat;
	font-style: normal;
	font-weight: normal;
	font-size: 1.4rem;
	line-height: 130%;
	color: #ffffff;
	padding: 1rem;
	margin: 6px 0;
	svg {
		margin-right: 5px;
	}
	div {
		width: 100%;
		word-break: break-word;
		white-space: break-spaces;
	}
`;

export const useDisclaimer = () => {
	const [disclaimer, setDisclaimerArr] = useRecoilState(userStore.disclaimerSettings);

	const setDisclaimer = (arr: IDisclaimer[]) => {
		const newObj: { [key in ESteps]?: string } = {};
		arr.forEach(disc => {
			newObj[disc.key] = disc.value;
		});
		setDisclaimerArr(newObj);
	};

	interface Props {
		step: ESteps;
	}

	const DisclaimerMessage = ({ step }: Props) => {
		return (
			<Fragment>
				{disclaimer[step] && (
					<div css={container}>
						<BsInfo />
						<div>{disclaimer[step]}</div>
					</div>
				)}
			</Fragment>
		);
	};

	return { setDisclaimer, disclaimer, DisclaimerMessage };
};
